import React, { Component } from 'react';
import { Checkbox, Col, DatePicker, Form, Icon, Input, Modal, Row } from 'antd';
import { queryDeleteAttachment, queryFilePreview } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFileTable';
import moment from 'moment';

const FormItem = Form.Item;

class ModalAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
  }

  componentDidMount() {
    const { renewalFiles } = this.props;
    const { files } = this.state;
    renewalFiles &&
      renewalFiles.map(item => {
        item.delFiles = [];
        files.push(item);
        return 1;
      });
    this.setState({ files });
  }

  componentWillReceiveProps(nextProps) {
    const { renewalFiles } = nextProps;
    const { files } = this.state;
    if (renewalFiles.length !== this.props.renewalFiles.length) {
      renewalFiles &&
        renewalFiles.map(item => {
          item.delFiles = [];
          files.push(item);
          return 1;
        });
      this.setState({ files });
    }
  }

  formatList = arr => {
    arr.map(item => {
      item.label = item.name;
      item.value = item.uuid;
      item.children && this.formatList(item.children);
      return item;
    });
  };

  handleOk = () => {
    const { files } = this.state;
    const params = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        files.map(item => {
          const it = { ...item };
          it.scans = values[`scans${item.uuid}`];
          it.no = values[`no${item.uuid}`];
          it.isArchive = values[`isArchive${item.uuid}`];
          it.endDate = values[`endDate${item.uuid}`]
            ? values[`endDate${item.uuid}`].format('yyyy-MM-DD')
            : null;
          it.reminderDate = values[`reminderDate${item.uuid}`]
            ? values[`reminderDate${item.uuid}`].format('yyyy-MM-DD')
            : null;
          if (it.delFiles.length > 0) {
            it.delFiles.map(i => {
              queryDeleteAttachment({
                uuid: i.uuid || i.uid,
              }).then(() => {});
              return i;
            });
          }
          params.push(it);
          return item;
        });
        this.props.handleOk(params);
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = (item, file) => {
    item.delFiles.push(file);
  };

  renewalFilesItem = item => {
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
    const { files } = this.state;
    return (
      <div>
        <Row>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem>
              {item.files.map(it => {
                return (
                  <div key={it.url}>
                    <a onClick={() => queryFilePreview(it)}>{it.name}</a>
                  </div>
                );
              })}
            </FormItem>
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {getFieldValue(`isArchive${item.uuid}`) ? (
              <FormItem style={{ margin: 0, height: '60px' }}>
                {getFieldDecorator(`no${item.uuid}`)(<Input placeholder="请填写文件编号" />)}
              </FormItem>
            ) : null}
          </Col>
          <Col span={5} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px', paddingTop: '4px' }}>
              {getFieldDecorator(`scans${item.uuid}`, {
                initialValue: item.scans,
              })(
                <UploadFile
                  type="ghost"
                  fileList={item.scans}
                  style={{ width: '60%' }}
                  onRemove={file => this.fileRemove(item, file)}
                  isPreview
                />,
              )}
            </FormItem>
          </Col>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px', paddingTop: '4px' }}>
              {getFieldDecorator(`isArchive${item.uuid}`, {
                initialValue: item.isArchive,
                valuePropName: 'checked',
              })(
                <Checkbox
                  onChange={e => {
                    if (files && files.length > 0) {
                      files.forEach(it => {
                        if (it.uuid !== item.uuid) {
                          setFieldsValue({
                            [`isArchive${it.uuid}`]: !e.target.checked,
                          });
                        }
                      });
                    }
                  }}
                />,
              )}
            </FormItem>
          </Col>
          <Col span={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {getFieldValue(`isArchive${item.uuid}`) && (
              <FormItem style={{ margin: 0, height: '60px', paddingTop: '4px' }}>
                {getFieldDecorator(`endDate${item.uuid}`, {
                  initialValue: item.endDate ? moment(item.endDate) : null,
                  rules: [{ required: true, message: '提醒必填!' }],
                })(<DatePicker />)}
              </FormItem>
            )}
          </Col>
          <Col span={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {getFieldValue(`isArchive${item.uuid}`) && (
              <FormItem style={{ margin: 0, height: '60px', paddingTop: '4px' }}>
                {getFieldDecorator(`reminderDate${item.uuid}`, {
                  initialValue: item.reminderDate ? moment(item.reminderDate) : null,
                  rules: [{ required: true, message: '到期时间必填!' }],
                })(<DatePicker />)}
              </FormItem>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  emptyInfo = () => {
    const _this = this;
    Modal.confirm({
      icon: <Icon type="login" />,
      title: '没有需要归档的文件,点击确定直接通过',
      onOk() {
        _this.handleOk();
      },
      onCancel() {
        _this.props.handleCancel(false);
      },
    });
  };

  render() {
    const { visible, handleCancel, confirmLoading } = this.props;
    const { files } = this.state;
    if (files.length) {
      return (
        <Modal
          title="行政文件归档"
          visible={visible}
          onOk={this.handleOk}
          okText="通过"
          confirmLoading={confirmLoading}
          onCancel={() => handleCancel(false)}
          width="65%"
        >
          <Row>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              附件(用章后)
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              文件编号
            </Col>
            <Col span={5} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              上传扫描件
            </Col>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              是否归档
            </Col>
            <Col span={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              到期时间
            </Col>
            <Col span={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              提醒时间
            </Col>
          </Row>
          <Form>
            {files.map(item => {
              return this.renewalFilesItem(item);
            })}
          </Form>
        </Modal>
      );
    }
    return <div>{visible ? this.emptyInfo() : null}</div>;
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/renewal/ModalArchiveUpload.js